
<div class="form-group" id="multiselect-example">

  @for (item of items; track item) {
    <label [ngClass]="'custom-input custom-input--checkbox custom-input--vehicle'">
      <input type="checkbox" [checked]="item.checked" (click)="checkMultiSelect()" [value]="item.item_id" name="{{uniqueControlName}}">
      <span class="custom-input__indi"></span>
      <span class="custom-input__label">
        <h5 class="font-16">{{item.header}}</h5>
        <p class="helper-text">{{item.description}}</p>
      </span>
    </label>
  }

</div>